import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { List } from "immutable";
import { formValueSelector, autofill as formChange } from "redux-form";

import {
  selectAllocation,
  setGatewayError,
  updateAllocationAmount,
  getSelectedAllocations,
} from "../../../../data/giving-form/allocation-selection";

import SelectedAllocation from "../components/SelectedAllocation";
import { FormattedMessage } from "react-intl";

export class SelectedAllocations extends React.Component {
  static propTypes = {
    selectedAllocations: PropTypes.instanceOf(List),
    totalAmount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  componentDidUpdate(props) {
    this.focusNewAllocation(props);
  }

  focusNewAllocation(props) {
    const current_allocations_count = $(".cause-selected").length;
    const previous_allocations_conut = props.selectedAllocations.size;

    if (current_allocations_count > previous_allocations_conut) {
      $(".cause-selected input")[previous_allocations_conut].focus();
    }
  }

  renderAllocations() {
    const { selectedAllocations, handleAllocationSelect, changeAmount, totalAmount } =
      this.props;
    const content = [];

    if (selectedAllocations.count() > 0) {
      selectedAllocations.map((allocation, idx) => {
        content.push(
          <SelectedAllocation
            key={idx}
            allocation={allocation}
            onAmountChange={changeAmount}
            onSelectAllocation={handleAllocationSelect}
            totalAmount={totalAmount}
          />,
        );
      });
    } else {
      content.push(
        <div key={"empty"} className="text-center m-sm-t">
          <span>
            <strong>
              <FormattedMessage id="selectFund" />
            </strong>
          </span>
        </div>,
      );
    }

    return content;
  }

  render() {
    return (
      <div>
        <div className="voting-picks-top">
          <i className="fa fa-2x fa-check-circle-o" />
          <span className="voting-picks-title">
            <FormattedMessage id="givingTo" />
          </span>
        </div>
        {this.renderAllocations()}
      </div>
    );
  }
}

const selector = formValueSelector("donation");

const mapStateToProps = (state) => {
  return {
    totalAmount: selector(state, "amount"),
    selectedAllocations: getSelectedAllocations(state),
  };
};

const ensureValidPositiveNumber = (amount) => {
  amount = Math.abs(amount);

  if (Number.isNaN(amount)) {
    amount = 0;
  }

  return amount;
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeAmount: (allocation, amount, totalAmount) => {
      let amountDifference;
      totalAmount = parseFloat(`${totalAmount}`.replace(/,/g, "") || 0).toFixed(2);
      amount = parseFloat(amount).toFixed(2);

      amount = ensureValidPositiveNumber(amount);

      try {
        const allocationAmount = allocation.get("amount") || 0;
        amountDifference = parseFloat(amount) - allocationAmount;
      } catch (e) {}

      let newAvailableAmount = parseFloat(totalAmount) + amountDifference;
      newAvailableAmount = isNaN(newAvailableAmount) ? 0 : newAvailableAmount;

      dispatch(updateAllocationAmount(allocation, amount || 0));
      dispatch(formChange("donation", "amount", newAvailableAmount.toFixed(2)));
    },

    handleAllocationSelect(allocation, bool, totalAmount) {
      let newAvailableAmount = parseFloat(totalAmount) - allocation.get("amount");

      dispatch(setGatewayError());
      dispatch(selectAllocation(allocation, bool, totalAmount));
      dispatch(formChange("donation", "amount", newAvailableAmount.toFixed(2)));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectedAllocations);
